import { Component, OnInit, OnDestroy} from '@angular/core';
import * as _ from 'lodash';
import { FarmSiteService } from 'src/app/services/farmSite.service';
import FarmSiteModel from 'src/app/services/farmSite.model';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import DeviceHealthModel from 'src/app/services/deviceHealthModel';
import { DeviceHealthService } from 'src/app/services/device-health.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;

@Component({
  selector: 'app-device-health-monitoring',
  templateUrl: './device-health-monitoring.component.html',
  styleUrls: ['./device-health-monitoring.component.scss']
})
export class DeviceHealthComponent implements OnInit, OnDestroy{
  public deviceHealths: Array<DeviceHealthModel> | any;
  public originaldeviceHealthData: Array<DeviceHealthModel>;
  public farmSites: Array<FarmSiteModel>;
  public pgLoad = false;
  public loginPersonType: any;
  public loginUserBusinessName: any;
  public loginBusinessName: any;
  public isSearchClicked: any;
  public deviceAsc: boolean = false;
  public startdateAsc: boolean = false;
  // sorting pagination
  public key: string = 'name';
  public reverse: boolean = false;
  public search: string;

  sort(key: string) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  // pagination sorting
  public currentpagenum: number = 1;
  public noofitemsPerPage: number = 10;
  /* End pagination, sorting, filter*/
  public activePageNo: number;

  constructor(public deviceHealthService: DeviceHealthService, public farmSiteService: FarmSiteService, public toastr: ToastrService, 
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService
  ) { }

  public async ngOnInit() {
    try {
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      // loginperson type details
      this.loginPersonType = localStorage.getItem('loginPersonType');
      // login person Business name
      this.loginUserBusinessName = localStorage.getItem('loginBusinessName');
      this.isSearchClicked = false; // if data is not available
      this.pgLoad = false;
      this.isSearchClicked = false;
      this.deviceHealths = await this.deviceHealthService.deviceHealth();
      this.pgLoad = true;
      this.originaldeviceHealthData = Object.assign({}, this.deviceHealths);
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

//To cancel ongoing requests and unsubscribe from subscriptions.
public ngOnDestroy(): void {
  this.deviceHealthService.cancelOnGoingHttpRequests();
}

  // sorting
  public async sortingTanks(type: string) {
    if (type == 'device') {
      this.deviceAsc = !this.deviceAsc;
      let orderbyval: 'asc' | 'desc' = 'desc';
      if (this.deviceAsc == true) {
        orderbyval = 'asc';
      }
      this.deviceHealths = _.orderBy(this.originaldeviceHealthData, ['device_number'], [orderbyval] as Array<'asc' | 'desc'>);
      this.startdateAsc = false;
    }
    if (type == 'startdate') {
      this.startdateAsc = !this.startdateAsc;
      let orderbyval: 'asc' | 'desc' = 'desc';
      if (this.startdateAsc == true) {
        orderbyval = 'asc';
      }
      this.deviceHealths = _.orderBy(this.originaldeviceHealthData, ['data.device_data.start_date'], [orderbyval] as Array<'asc' | 'desc'>);
      this.deviceAsc = false;
    }
  }

  public async searchByDeviceNumber() {
    try {
      let searchvalue = this.search.toLowerCase();
      this.deviceHealths = _.filter(this.originaldeviceHealthData, function (obj: { device_number: string; }) {
        if (obj.device_number && ('' + obj.device_number).toLowerCase().indexOf(searchvalue) != -1) {
          return true;
        }
        return false;
      });
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  public pageChange(pageNum: number) {
    this.activePageNo = pageNum;
  }
}